import React from "react";
import { i18n } from "../../translate/i18n";
import { Avatar, CardHeader, Grid } from "@material-ui/core";
import { ticketAiStatus } from "../../helpers/ticketAiStatus";

const TicketInfo = ({ contact, ticket, onClick }) => {
	const renderCardReader = () => {
		return (
			<CardHeader
				onClick={onClick}
				style={{ cursor: "pointer" }}
				titleTypographyProps={{ noWrap: true }}
				subheaderTypographyProps={{ noWrap: true }}
				avatar={<Avatar src={contact?.urlPicture} alt="contact_image" />}
				title={`${contact?.name || '(sem contato)'} #${ticket.id}`}
				subheader={["automation", "waiting_human"].includes(ticket.aiServiceStatus)
					? ticketAiStatus(ticket).label
					: ticket.user && `${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`}
			/>
		);
	};

	return (
		<React.Fragment>
			<Grid container alignItems="center" spacing={2}>
				<Grid item xs>
					{renderCardReader()}
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default TicketInfo;
